import AddIcon from "@mui/icons-material/Add";
import { Alert, Button } from "@mui/material";
import React, { useState } from "react";
import Modal from "../elements/Modal";
import QuestionForm from "./AiSurveyQuestion";
import { addQuestion } from "../../api/products";
import useAuthToken from "../../hooks/getUserData";

const AddQuestion = ({
  fetchQuestions,
  setMessage,
  setSnackbarOpen,
  categories,
}) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const token = useAuthToken();

  const formatValuesForApi = (values) => {
    const base = {
      categoryId: values.category,
      title: values.title,
      description: values.description,
      type: values.questionType,
    };

    if (values.questionType === "single_choice") {
      base.options = values.options.map((opt, idx) => ({
        sno: idx + 1,
        title: opt.heading,
        description: opt.subtitle,
      }));
      const defaultOpt = values.options.find((opt) => opt.default);
      if (defaultOpt) {
        base.defaultAnswer = defaultOpt.heading;
      }
    } else if (values.questionType === "choice_with_other") {
      base.options = values.options.map((opt, idx) => ({
        sno: idx + 1,
        title: opt.heading,
        value: opt.heading.replace(/[^a-zA-Z0-9]/g, "").toLowerCase(),
      }));
      base.inputLabel = values.textfieldConfig.label;
      base.inputPlaceholder = values.textfieldConfig.placeholder;
    } else if (
      ["single_line_textbox", "multi_line_textbox", "url_input"].includes(
        values.questionType
      )
    ) {
      base.inputLabel = values.textfieldConfig.label;
      base.inputPlaceholder = values.textfieldConfig.placeholder;
    }

    return base;
  };

  const handleSubmit = async (values) => {
    setError(null);
    try {
      const formattedValues = formatValuesForApi(values);
      const res = await addQuestion(token, formattedValues);
      if (res.ok) {
        setSnackbarOpen(true);
        setMessage("Question added successfully");
        handleClose(); 
        await fetchQuestions(true); 
      } else {
        const errorData = await res.json().catch(() => ({}));
        setError(errorData.error?.message || "Failed to add question");
      }
    } catch (error) {
      console.error("Error adding question:", error);
      setError("Failed to add a new question");
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setError(null);
  };

  return (
    <>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={handleClickOpen}
      >
        Add Question
      </Button>

      <Modal
        open={open}
        modalTitle="Add Question"
        handleClose={handleClose}
        width="sm"
      >
        {error && <Alert severity="error">{error}</Alert>}
        <QuestionForm onSubmit={handleSubmit} categories={categories} />
      </Modal>
    </>
  );
};

export default AddQuestion;
